import React from "react";

import { DEFAULT_CARD_HEIGHT, TAG } from "config/constants";
import TagStreamWrapper from "stream/containers/TagStreamWrapper";
import Stream from "stream/containers/Stream";
import FullStoryCard from "cards/containers/FullStoryCard";
import AxiosVisualsStreamCap from "stream/components/AxiosVisualsStreamCap";
import MidtermsTagStreamHeader from "stream/components/MidtermsTagStreamHeader";

export default function MidtermsTagStream() {
  return (
    <TagStreamWrapper
      slug={TAG.MIDTERM_ELECTIONS_2018.slug}
      headerComponent={MidtermsTagStreamHeader}
    >
      {({ streamParams }) => (
        <>
          <AxiosVisualsStreamCap slug="2018-11-06-balance-of-power" />
          <Stream
            {...streamParams}
            defaultCardHeight={DEFAULT_CARD_HEIGHT.FULL_STORY_CARD}
            contentComponent={FullStoryCard}
          />
        </>
      )}
    </TagStreamWrapper>
  );
}
